const colors = {
  WHITE: 'white',
  BLACK: 'black',
  GREY: '#808080'
}
export default colors;